import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Grid,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  Chip,
  debounce,
  Autocomplete,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
import Sidebar from "../../components/sidebar/sidebar";
import {
  fetchPigmyWithdrawRequestService,
  updatePigmyWithdrawStatusService,
  // updatePigmyWithdrawStatusService,
} from "../../services/pigmyService";
import axios from "axios";
import { API_URL } from "../../utils/apiUtils";

function WithdrawPigmyRequest() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [enquires, setEnquires] = useState([]);
  const [page, setPage] = useState(0);
  const [userId, setuserId] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCollections, setTotalCollections] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [raiseWithdrawOpen, setRaiseWithdrawOpen] = useState(false);
  const openRaiseWithdrawModal = () => setRaiseWithdrawOpen(true);
  const closeRaiseWithdrawModal = () => {
    setRaiseWithdrawOpen(false);
    setSavingAmount(null);
  };
  const [loading, setLoading] = useState(false);
  const statuses = ["pending", "complete", "reject"];
  const initialValues = { fromDate: null, toDate: null, status: "" };
  const token = sessionStorage.getItem("accessToken");
  const [savingAmount, setSavingAmount] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [options, setOptions] = useState([]);
  const fetchOptions = async (query) => {
    if (!query) return;
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/pigmy/search-pigmy`, {
        params: { query },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOptions(response.data.customers);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
    setLoading(false);
  };

  const raisePigmyWithdrawRequestService = async (pigmyId, amount, token, reason) => {
    const response = await axios.post(
      `${API_URL}/pigmy/admin-withdraw-request`,
      {
        withdrawalAmount: amount,
        pigmyId: pigmyId,
        reason,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  };

  const debouncedFetchOptions = useCallback(
    debounce((query) => {
      fetchOptions(query);
    }, 300),
    []
  );
  const fetchSavingAmount = async (pigmyId) => {
    try {
      const response = await axios.get(
        `${API_URL}/pigmy/get-saving-amount?id=${pigmyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(
        "Saving Amount Response:",
        response.data.getSavings?.pigmySavings
      );
      setSavingAmount(response.data.getSavings?.pigmySavings);
      // adjust key based on your backend response
      //setSavingAmount(response.data.savingAmount);
    } catch (error) {
      toast.error("Failed to fetch saving amount");
      console.error(error);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchEnquires = async (values) => {
    try {
      const getLoans = await fetchPigmyWithdrawRequestService(
        values.fromDate,
        values.toDate,
        page,
        rowsPerPage,
        values.status
      );
      setEnquires(getLoans?.withdrawRequests);
      setTotalCollections(getLoans?.totalCollections);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const openConfirmDialog = (id, status, userId) => {
    setSelectedRow(id);
    setuserId(userId);
    setSelectedStatus(status);
    setDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDialogOpen(false);
    setSelectedRow(null);
    setSelectedStatus("");
  };

  const handleStatusChange = async () => {
    try {
      const updateStatus = await updatePigmyWithdrawStatusService(
        selectedRow,
        selectedStatus,
        userId
      );
      if (updateStatus?.status) toast.success("Status updated successfully!");
      setEnquires((prevEnquires) =>
        prevEnquires.map((enquiry) =>
          enquiry._id === selectedRow
            ? { ...enquiry, status: selectedStatus }
            : enquiry
        )
      );
      closeConfirmDialog();
    } catch (error) {
      toast.error("Failed to update status. Please try again.");
    }
  };

  useEffect(() => {
    fetchEnquires(initialValues);
  }, [page, rowsPerPage]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Typography variant="h4">Pigmy Withdraw Requests</Typography>
          <Paper
            style={{
              color: "#000",
              padding: "20px",
              marginTop: 20,
              borderRadius: "10px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => {
                fetchEnquires(values);
              }}
            >
              {({ values, handleChange }) => (
                <Form>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={2}>
                      <Typography variant="body2" color="#333">
                        From Date
                      </Typography>
                      <TextField
                        type="date"
                        name="fromDate"
                        size="small"
                        value={values.fromDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography variant="body2" color="#333">
                        To Date
                      </Typography>
                      <TextField
                        type="date"
                        name="toDate"
                        size="small"
                        value={values.toDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Button type="submit" variant="contained" color="primary">
                        Filter
                      </Button>
                      <Button 
                        variant="outlined"
                        color="secondary"
                        onClick={openRaiseWithdrawModal}
                        style={{ marginLeft: 10 }}
                      >
                        Raise Withdraw Request
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Paper>

          <Box sx={{ mt: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {[
                      "SL.NO",
                      "Customer Name",
                      "Phone Number",
                      "Amount",
                      "Requested Date",
                      "Reason",
                      "Status",
                      "Actions",
                    ].map((header) => (
                      <TableCell key={header}>{header}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {enquires.length > 0 ? (
                    enquires.map((row, index) => (
                      <TableRow key={row._id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row.user?.userName}</TableCell>
                        <TableCell>
                          {row.user?.primaryPhone?.contactValue}
                        </TableCell>
                        <TableCell>{row.amount}</TableCell>
                        <TableCell>
                          {moment(row.createdAt).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell>{row.reason}</TableCell>
                        <TableCell>
                          {row.status === "complete" ? (
                            <Chip
                              label="Completed"
                              style={{
                                backgroundColor: "green",
                                color: "white",
                              }}
                            />
                          ) : row.status === "reject" ? (
                            <Chip
                              label="Rejected"
                              style={{ backgroundColor: "red", color: "white" }}
                            />
                          ) : (
                            <Chip
                              label={row.status}
                              style={{
                                backgroundColor: "gray",
                                color: "white",
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <Select
                            value={row.status}
                            disabled={["complete", "reject"].includes(
                              row.status
                            )}
                            onChange={(e) =>
                              openConfirmDialog(
                                row._id,
                                e.target.value,
                                row?.user?._id
                              )
                            }
                            fullWidth
                            size="small"
                          >
                            {statuses.map((status) => (
                              <MenuItem key={status} value={status}>
                                {status}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No enquiries available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCollections}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>
      </Box>

      {/* Confirmation Dialog */}
      <Dialog open={dialogOpen} onClose={closeConfirmDialog}>
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the status to{" "}
            <b>{selectedStatus}</b>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmDialog} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleStatusChange}
            color="primary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={raiseWithdrawOpen}
        onClose={closeRaiseWithdrawModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Raise Pigmy Withdraw Request</DialogTitle>

        <Formik
          initialValues={{ pigmy: "", withdrawAmount: "", reason: "" }}
          validationSchema={Yup.object({
            pigmy: Yup.string().required("Please select a Pigmy"),
            withdrawAmount: Yup.number()
              .required("Withdraw amount is required")
              .positive("Amount must be greater than 0")
              .test(
                "max-balance",
                "Withdraw amount cannot be more than available balance",
                function (value) {
                  return savingAmount == null || value <= savingAmount;
                }
              ),
            reason: Yup.string()
              .required("Reason is required")
              .min(5, "Reason must be at least 5 characters"),
          })}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              await raisePigmyWithdrawRequestService(
                values.pigmy,
                values.withdrawAmount,
                token,
                values.reason
              );

              toast.success("Withdraw request raised successfully!");
              resetForm();
              closeRaiseWithdrawModal();
              fetchEnquires(initialValues); // refresh table
            } catch (error) {
              toast.error(
                error?.response?.data?.message ||
                  "Failed to raise withdraw request"
              );
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, setFieldValue, touched, errors }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                      Customer Name / Pigmy Code / Phone Number
                    </Typography>

                    <Autocomplete
                      value={
                        options.find((option) => option._id === values.pigmy) ||
                        null
                      }
                      onChange={(event, newValue) => {
                        const pigmyId = newValue ? newValue._id : "";
                        setFieldValue("pigmy", newValue ? newValue._id : "");
                        if (pigmyId) {
                          fetchSavingAmount(pigmyId); // 🔥 API call here
                        } else {
                          setSavingAmount(null);
                        }
                      }}
                      onInputChange={(event, newInputValue) => {
                        if (event && event.type === "change") {
                          debouncedFetchOptions(newInputValue);
                        }
                      }}
                      options={options}
                      getOptionLabel={(option) =>
                        `${option.user.userName} (${option.pigmyCode}) (${option.user.primaryPhone?.contactValue})`
                      }
                      loading={loading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search by name, pigmy code or phone"
                          size="small"
                          error={Boolean(touched.pigmy && errors.pigmy)}
                          helperText={touched.pigmy && errors.pigmy}
                        />
                      )}
                    />
                  </Grid>
                  {savingAmount !== null && (
                    <Grid item xs={12}>
                      <Typography variant="body2" color="green">
                        Available Balance: ₹ {savingAmount}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                      Withdraw Amount
                    </Typography>

                    <TextField
                      fullWidth
                      size="small"
                      type="number"
                      name="withdrawAmount"
                      placeholder="Enter withdraw amount"
                      value={values.withdrawAmount}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (savingAmount !== null && value > savingAmount) {
                          setFieldValue("withdrawAmount", savingAmount);
                        } else {
                          setFieldValue("withdrawAmount", e.target.value);
                        }
                      }}
                      error={Boolean(
                        touched.withdrawAmount && errors.withdrawAmount
                      )}
                      helperText={
                        touched.withdrawAmount && errors.withdrawAmount
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                      Reason
                    </Typography>

                    <TextField
                      fullWidth
                      size="small"
                      name="reason"
                      placeholder="Enter reason for withdrawal"
                      multiline
                      rows={3}
                      value={values.reason}
                      onChange={(e) => setFieldValue("reason", e.target.value)}
                      error={Boolean(touched.reason && errors.reason)}
                      helperText={touched.reason && errors.reason}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button onClick={closeRaiseWithdrawModal}>Cancel</Button>
                <Button type="submit" variant="contained">
                  Submit Request
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
}

export default WithdrawPigmyRequest;
